import { api } from '@services/apiService';
import { billingStripeCheckout } from '@utils/resources/billing';

import handleRawApiError from './handleRawApiError';

/**
 *
 * @param {string} teamUuid
 * @returns
 */
const getStripeCheckoutUrl = handleRawApiError(async (teamUuid) =>
  api.get(billingStripeCheckout(teamUuid)).json()
);

export default getStripeCheckoutUrl;
